import { useState } from "react";
import { useComunas, type ComunaDB } from "@/hooks/useComunas";
import { useIndicadores, type IndicadorDB } from "@/hooks/useIndicadores";

interface ComunaData {
  id: string;
  nombre: string;
  habitantes: number;
  especialistas: number;
  centrosMedicos: number;
  dot: { cx: number; cy: number };
  imagen: string;
  pathIndices: number[];
}

const solidoPaths: Array<
  | { type: "polygon"; points: string; id?: string; dataComuna?: string }
  | { type: "path"; d: string; id?: string; dataComuna?: string }
> = [
  { type: "path", d: "M1294.42,1112.93h-.18c-.15,0-.34,0-.56.02.24-.01.49-.02.75-.02Z" },
  {
    type: "polygon",
    points:
      "218.24 1507.62 226.97 1491.42 230.9 1411.42 211.81 1358.38 229.17 1299.21 212.58 1289.44 210.41 1322 193.28 1374.03 205.78 1401.23 187.09 1428.29 212.87 1455.91 218.24 1507.62",
  },
  {
    type: "path",
    d:
      "M224.65,1538.55l13.61,20.21,72.34-50.64,51.85,23.98,18.78-35.56,38.58-47.56,4.75-123.02,6.24-63c-32.39,6.96-118.54,26.07-181.61,40.13l-16.04,54.66,18.23,50.63-4.36,88.64-22.37,41.55Z",
  },
  {
    type: "path",
    d:
      "M214.09,1266.77l28.75,16.93c195.56-43.6,197.98-43.6,199.42-43.6,4.12,0,6.04,0,83.22,56.65l91.4-19.07,469.24-121.48,2.3.47c35.55,7.25,91.79,18.61,104.46,20.89,6.32-3.38,24.67-14.72,40.78-25.02l1.29-.82,37.18-10.26c1.29-2.59,3.07-6.09,4.92-9.62,6.69-12.74,9.88-18.3,16.26-18.86,3.9-.82,24.32-6.24,43.74-11.47l-33.09-24.27-8.68-62.01,120.67-90.5-.74-11.75,6.5-103.99,22.92-22.92-7.85-20.27-57.77-6.85-143.99-106.33,87.93-164.34-53.64-61.83-36.72-.85-41.67,29.63-25.49,56.29-32.82,12.31-12.98,34.21-34.82-8.7-43.22,15.25v45.06l-109.77,97.82-158.41,48.16-18.18,33.4-78.72,20.21-102.55,87.38v-488.86l103.46-10.46,68.6-57.68,84.43-5.15,50.23-51.68,58.02-104.34v-11.4l-19.97-13.83h-22.03l-31.96,16.35-23.19-10.82h-245.07l-39.31,17.62-54.26,8.92-50.37-17.12-28.69,24.16-41.77-6.43-152.33,76.92-35.74,41.91-144.01,74.32v54.82l19.23,61.8,23.47,31.07,35.44,110.57.1,1.16,6.3,76.29-4.72,44.1-21.9,16.17,69.47,54.68-12.11,44.17,22.31,26.24,4.21,114.96,13.45,31.14-9,80.27,23.41,57.14-5.54,83.16Z",
  },
  {
    type: "polygon",
    points:
      "839.53 354.24 753.95 359.46 685.7 416.85 594.26 426.09 594.26 852.63 666.91 790.73 741.62 771.54 759.56 738.6 921.65 689.32 1021.29 600.52 1021.29 550.21 1083.82 528.14 1107.05 533.95 1116.89 508.03 1150.41 495.46 1174.69 441.85 1180.35 437.82 1159.87 429.93 1057.05 377.44 1046.55 339.18 1020.36 294.81 1025.1 271.95 1025.1 255.9 1021.03 232.67 1003.79 217.65 965.02 204.05 952.38 195.62 897.12 294.99 839.53 354.24",
  },
  {
    type: "polygon",
    points:
      "1824.06 448.37 1731.87 428.39 1710.7 385.18 1697.2 350.47 1669.52 328.94 1617.49 309.25 1592.16 280.94 1561.38 244.69 1534.97 219.1 1511.19 205.18 1484.77 199.62 1452.57 179.49 1429.18 112.22 1422.5 90.83 1411.03 67.3 1399.21 60.3 1368.27 72.15 1353.41 68.27 1336.14 78.9 1340 98.67 1354.16 123.22 1308 155.62 1282.52 182.47 1240.47 213.8 1208.3 234.48 1179.83 230.63 1126.71 231.96 1081.76 245.44 1044.5 278.36 1041.84 291.25 1065.41 331.2 1074.26 363.43 1168.63 411.61 1200.18 423.72 1226.32 405.13 1278.76 406.35 1347.44 485.52 1261.21 646.7 1386.75 739.41 1451.31 747.07 1464.56 781.29 1515.55 807.32 1524.97 852.94 1556.57 888.14 1553.17 919.31 1652.41 918.45 1654.2 896.93 1732.81 860.25 1745.65 804.95 1746.91 803.25 1904.97 590.39 1942.74 585.42 1950 567.27 1880.75 518.22 1824.06 448.37",
  },
  {
    type: "path",
    d:
      "M1530.52,939.81l4.89-44.85-29.21-32.53-8.55-41.45-39.19-20-16.95,16.95-5.94,95.06,1.34,21.42-119.85,89.88,5.83,41.66,46.92,34.41,7.48,88.7,16.39,32.78-17.46,66.36-22.38,15.85,13.53,60.42,39.13,46.03-38.8,47.03-40.83,87.34-175.56-70.01-158.29,16.45-112.2-13.31-3.97,493.88,94.15-7.31,67.19-27.73,67.23,20.51,13.88,14.8,42.93-5.26,14.13-10.87,76.44,2.04,30-36,55.81-15.12,44.09,14.7,21.96,41.48-4.37,51.31-3.07,361.4,68.25,70.29,34.94,113.31,312.86-222.71,64.11-117.43-26.47-5.15-47.74-43.19-14.19-47.3,27.69-81.02-16.42-33.81-5.8-33.36,23.5-9.4,5.68-23.66,48.6-47.44h36.05l4.77-15.37-33.32-20.31h-46.44l-10.43-39.65c-4.45-.18-10.36-.48-16.34-.94-21.76-1.67-30.03-4.23-32.7-10.78-5.13-5.58-31.03-25.79-54.23-42.97h-25.42l-86.88-77.97-3.44-63.09,12.75-39.52,68.71-14.57,8.69-23.39-40.38-25.96-6.6-36.29-13.87-19.2-3.46-61.18,22.43-35.1-10.97-20.72-30.15,17.39-10.64-54.56-22.98-35.91,113.11-30.96h90.4l41.65-85.24,14.28-34.82-31.14-41.88,26.51-35.73.44-8.29-82.38-20.59-56.74-73.24-32.53-5.42-130.44,1.13Z",
  },
  {
    type: "path",
    d:
      "M461.33,2574.72l-12.57-56.22-7.57-132.68h77.08l-162.43-238.52-80.9-201.46,26.55-115.57-75.17-252.88-22.58-33.54-12.38,22.76-25.17,26.29,18.76,18.76v129.77l-33.39,29.12-11.94,57.82,20.47,73.02-2.1,107.55,1.51,27.23-14.74,28.91,22.35,12.24,42.22,57.3-2.73,43.65,21.51,23.81-21.05,35.36-21.04,37.33-10.39,25.71,33.47,34.1,17.94,47.57-1.18,3.45c-3.33,9.76-7.1,21.18-8.62,26.29,5.68,12.09,30.81,61.31,46.74,92.26l1.8,3.5-8.64,31.91,27.55,33.45,5.2,39.87-36.98,34.34,41.76,84.12,70.16,5.54,31.71-16.42,13.54-73.81,31.41-28.55,19.83-43.38Z",
    id: "iquique-franja-costera-sur",
    dataComuna: "iquique",
  },
  {
    type: "path",
    d:
      "M1376.85,2383.98l3.18-370.9,3.89-45.75-15.36-29.02-30.56-10.19-43.71,11.84-32.2,38.64-79.07-2.11-12.82,9.86-58.67,7.18-17.22-18.37-55.1-16.81-63.44,26.18-119.41,9.27,4.33-538.67,132.46,15.72,161.01-16.73,162.41,64.76,33.81-72.31,29.62-35.91-31.36-36.9-17.58-78.5,27.39-19.4,13.64-51.82-14.71-29.42-6.4-75.86c-31.31,8.48-44.82,11.98-50.95,13.43-2.63,4.33-7.7,14.06-11.7,22.27l-2.01,4.12-43.03,11.87c-43.41,27.72-45.8,27.73-49.1,27.73-1.31,0-3.75,0-107.54-21.16l-465.17,120.42-100.74,21.02-3.65-2.68c-24.28-17.83-50.98-37.16-66.4-47.94l-5.93,59.81-4.95,128.86-41.59,51.27-26.84,50.83-58.73-27.16-65.25,45.67,75.05,252.48-26.32,114.57,77.71,193.52,182.79,268.43h-93.98l6.25,109.56,13.69,61.27-24.4,53.37-29.41,26.74-11.78,64.18,22.81,10.41,114.06,5.19,23.43-33.84,34.33,45.22,71.51,11.33,30.63,78.03,78.32,102.14,239.1-249.2,257.72-71.24,193.07-50.57-34.52-111.95-70.66-72.77Z",
  },
];

const fallbackComunas: ComunaData[] = [
  {
    id: "alto-hospicio",
    nombre: "Alto Hospicio",
    habitantes: 108375,
    especialistas: 120,
    centrosMedicos: 5,
    dot: { cx: 280, cy: 1530 },
    imagen:
      "https://readdy.ai/api/search-image?query=Residential%20urban%20neighborhood%20in%20Alto%20Hospicio%20northern%20Chile%2C%20desert%20landscape%20background%2C%20modern%20houses%2C%20dry%20climate%2C%20sunny%20day%2C%20Atacama%20desert%20surroundings%2C%20high%20quality%20photography&width=800&height=450&seq=1004&orientation=landscape",
    pathIndices: [2],
  },
  {
    id: "iquique",
    nombre: "Iquique",
    habitantes: 191468,
    especialistas: 487,
    centrosMedicos: 12,
    dot: { cx: 215, cy: 1420 },
    imagen:
      "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20the%20coastal%20city%20of%20Iquique%20in%20northern%20Chile%2C%20Pacific%20Ocean%20shoreline%2C%20historic%20buildings%2C%20port%20city%2C%20clear%20blue%20sky%2C%20warm%20afternoon%20light%2C%20high%20quality%20photography&width=800&height=450&seq=1005&orientation=landscape",
    pathIndices: [1, 7],
  },
  {
    id: "huara",
    nombre: "Huara",
    habitantes: 2806,
    especialistas: 12,
    centrosMedicos: 1,
    dot: { cx: 400, cy: 1100 },
    imagen:
      "https://readdy.ai/api/search-image?query=Rural%20village%20of%20Huara%20in%20Tarapaca%20desert%20Chile%2C%20adobe%20houses%2C%20church%20tower%2C%20arid%20mountains%20background%2C%20traditional%20northern%20Chile%20architecture%2C%20warm%20afternoon%20light%2C%20high%20quality%20photography&width=800&height=450&seq=1001&orientation=landscape",
    pathIndices: [3],
  },
  {
    id: "camina",
    nombre: "Camiña",
    habitantes: 1305,
    especialistas: 8,
    centrosMedicos: 1,
    dot: { cx: 800, cy: 600 },
    imagen:
      "https://readdy.ai/api/search-image?query=Small%20Andean%20village%20of%20Camina%20in%20Tarapaca%20Chile%2C%20terraced%20hillsides%2C%20desert%20valley%2C%20traditional%20rural%20architecture%2C%20northern%20Chile%20altiplano%2C%20clear%20sky%2C%20high%20quality%20photography&width=800&height=450&seq=1002&orientation=landscape",
    pathIndices: [4],
  },
  {
    id: "colchane",
    nombre: "Colchane",
    habitantes: 610,
    especialistas: 3,
    centrosMedicos: 1,
    dot: { cx: 1650, cy: 550 },
    imagen:
      "https://readdy.ai/api/search-image?query=Remote%20border%20village%20of%20Colchane%20in%20northern%20Chile%20altiplano%20near%20Bolivia%2C%20high%20altitude%20desert%2C%20vicuna%20grazing%2C%20Andean%20plateau%2C%20traditional%20Aymara%20community%2C%20vast%20open%20landscape%2C%20high%20quality%20photography&width=800&height=450&seq=1003&orientation=landscape",
    pathIndices: [5],
  },
  {
    id: "pica",
    nombre: "Pica",
    habitantes: 6272,
    especialistas: 79,
    centrosMedicos: 2,
    dot: { cx: 1500, cy: 1500 },
    imagen:
      "https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/b4ac2b7532a05b361531c0efdd27e563.png",
    pathIndices: [6],
  },
  {
    id: "pozo-almonte",
    nombre: "Pozo Almonte",
    habitantes: 13295,
    especialistas: 95,
    centrosMedicos: 3,
    dot: { cx: 900, cy: 2450 },
    imagen:
      "https://readdy.ai/api/search-image?query=Rural%20desert%20landscape%20of%20Pozo%20Almonte%20in%20Tarapaca%20region%20Chile%2C%20salt%20flat%2C%20mining%20operations%20in%20distance%2C%20arid%20terrain%2C%20dramatic%20sky%2C%20northern%20Chile%20pampa%2C%20high%20quality%20photography&width=800&height=450&seq=1006&orientation=landscape",
    pathIndices: [8],
  },
];

const fallbackLeftIndicators = [
  { valor: 75, titulo: "Cobertura", subtitulo: "de atención primaria en la región" },
  { valor: 90, titulo: "Acceso", subtitulo: "a centros de salud cercanos" },
  { valor: 30, titulo: "Capacidad", subtitulo: "de especialistas disponibles" },
];

const fallbackRightIndicators = [
  { valor: 62, titulo: "Telemedicina", subtitulo: "consultas remotas realizadas" },
  { valor: 85, titulo: "Satisfacción", subtitulo: "de usuarios del sistema" },
  { valor: 45, titulo: "Digitalización", subtitulo: "de historias clínicas en uso" },
];

function mapComunaDB(c: ComunaDB): ComunaData {
  return {
    id: c.id,
    nombre: c.nombre,
    habitantes: c.habitantes,
    especialistas: c.especialistas,
    centrosMedicos: c.centros_medicos,
    dot: { cx: c.dot_cx, cy: c.dot_cy },
    imagen: c.imagen,
    pathIndices: c.path_indices,
  };
}

function DonutIndicator({
  valor,
  titulo,
  subtitulo,
}: {
  valor: number;
  titulo: string;
  subtitulo: string;
}) {
  const radius = 15.9155;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (valor / 100) * circumference;

  return (
    <div className="flex flex-col items-center text-center flex-1 min-w-0">
      <p
        className="text-masmed-gray-700 text-[11px] md:text-xs mb-1 md:mb-2 whitespace-nowrap"
        style={{
          fontFamily: "'Arial', 'Helvetica', sans-serif",
          fontWeight: 700,
        }}
      >
        {titulo}
      </p>
      <div className="relative w-16 h-16 md:w-20 md:h-20">
        <svg viewBox="0 0 42 42" className="w-full h-full -rotate-90">
          <circle
            cx="21"
            cy="21"
            r={radius}
            fill="none"
            stroke="#E5E5E5"
            strokeWidth="5"
          />
          <circle
            cx="21"
            cy="21"
            r={radius}
            fill="none"
            stroke="#F15A24"
            strokeWidth="5"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            className="transition-all duration-700 ease-out"
          />
        </svg>
        <span
          className="absolute inset-0 flex items-center justify-center text-masmed-gray-700 text-xs md:text-sm"
          style={{
            fontFamily: "'Arial', 'Helvetica', sans-serif",
            fontWeight: 700,
          }}
        >
          {valor}%
        </span>
      </div>
      <p className="text-masmed-gray-500 text-[10px] md:text-xs mt-1 md:mt-2 max-w-[130px] leading-relaxed">
        {subtitulo}
      </p>
    </div>
  );
}

export default function TerritorySection({ territorioTitle = "Territorio" }: { territorioTitle?: string }) {
  const { data: dbComunas } = useComunas();
  const { data: dbIndicadores } = useIndicadores();
  const [selectedId, setSelectedId] = useState<string>("pica");

  const comunas = dbComunas.length > 0 ? dbComunas.map(mapComunaDB) : fallbackComunas;
  const leftIndicators = dbIndicadores.length > 0
    ? dbIndicadores.filter((i) => i.posicion === "left")
    : fallbackLeftIndicators;
  const rightIndicators = dbIndicadores.length > 0
    ? dbIndicadores.filter((i) => i.posicion === "right")
    : fallbackRightIndicators;

  const selectedComuna = comunas.find((c) => c.id === selectedId) ?? comunas[0];

  const handleSelect = (id: string) => {
    setSelectedId(id);
  };

  const tooltipLeft = (selectedComuna.dot.cx / 2000) * 100;
  const tooltipTop = (selectedComuna.dot.cy / 3000) * 100;

  return (
    <section className="py-10 md:py-14 lg:py-16 bg-masmed-gray-50">
      <div className="max-w-[1180px] mx-auto px-4 md:px-8 lg:px-12">
        {/* Título centrado */}
        <div className="text-center mb-6 md:mb-8 lg:mb-10">
          <h2 className="text-2xl md:text-[28px] text-masmed-gray-700 tracking-tight">
            {territorioTitle}
          </h2>
        </div>

        {/* Layout 3 columnas en desktop */}
        <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-8">
          {/* Columna izquierda: 3 donuts apilados */}
          <div className="w-full lg:w-[180px] flex flex-row lg:flex-col items-center justify-between gap-4 shrink-0 order-2 lg:order-1">
            {leftIndicators.map((ind, idx) => (
              <DonutIndicator
                key={`left-${idx}`}
                valor={ind.valor}
                titulo={ind.titulo}
                subtitulo={ind.subtitulo}
              />
            ))}
          </div>

          {/* Centro: Mapa SVG */}
          <div className="w-full lg:flex-1 order-1 lg:order-2">
            <div
              className="relative w-full"
              style={{ filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.08))" }}
            >
              <svg
                viewBox="0 0 2000 3000"
                className="w-full h-auto max-h-[70vh] mx-auto"
                style={{ maxWidth: "540px" }}
                preserveAspectRatio="xMidYMid meet"
                role="img"
                aria-label="Mapa interactivo de la Región de Tarapacá"
              >
                {solidoPaths.map((p, idx) => {
                  const comunaByData = p.dataComuna
                    ? comunas.find((c) => c.id === p.dataComuna)
                    : undefined;
                  const comuna =
                    comunaByData ?? comunas.find((c) => c.pathIndices.includes(idx));
                  const isSelected = comuna?.id === selectedId;
                  const fill = isSelected ? "#F15A24" : "#E0E0E0";
                  const stroke = isSelected ? "#D14A1A" : "#BDBDBD";

                  if (p.type === "polygon") {
                    return (
                      <polygon
                        key={idx}
                        id={p.id}
                        data-comuna={p.dataComuna}
                        points={p.points}
                        fill={fill}
                        stroke={stroke}
                        strokeWidth={isSelected ? 1.5 : 0.8}
                        className="cursor-pointer transition-all duration-300"
                        onClick={() => comuna && handleSelect(comuna.id)}
                        style={{ pointerEvents: comuna ? "all" : "none" }}
                      />
                    );
                  }

                  return (
                    <path
                      key={idx}
                      id={p.id}
                      data-comuna={p.dataComuna}
                      d={p.d}
                      fill={fill}
                      stroke={stroke}
                      strokeWidth={isSelected ? 1.5 : 0.8}
                      className="cursor-pointer transition-all duration-300"
                      onClick={() => comuna && handleSelect(comuna.id)}
                      style={{ pointerEvents: comuna ? "all" : "none" }}
                    />
                  );
                })}

                {/* Puntos circulares para comunas */}
                {comunas.map((comuna) => {
                  const isSelected = comuna.id === selectedId;
                  return (
                    <g
                      key={`dot-${comuna.id}`}
                      className="cursor-pointer"
                      onClick={() => handleSelect(comuna.id)}
                    >
                      <circle
                        cx={comuna.dot.cx}
                        cy={comuna.dot.cy}
                        r={isSelected ? 12 : 10}
                        fill={isSelected ? "#F15A24" : "#356182"}
                        stroke="white"
                        strokeWidth="2"
                        className="transition-all duration-300"
                      />
                      {isSelected && (
                        <circle
                          cx={comuna.dot.cx}
                          cy={comuna.dot.cy}
                          r={5}
                          fill="white"
                          className="pointer-events-none"
                        />
                      )}
                    </g>
                  );
                })}
              </svg>

              {/* Tooltip dinámico a la derecha del punto seleccionado */}
              <div
                className="absolute z-10 pointer-events-none hidden md:block"
                style={{
                  top: `${tooltipTop}%`,
                  left: `${tooltipLeft + 5}%`,
                  transform: "translateY(-50%)",
                }}
              >
                <div className="relative bg-white rounded-xl shadow-lg px-4 py-3 min-w-[170px]">
                  {/* Flecha apuntando hacia la izquierda */}
                  <div
                    className="absolute w-0 h-0"
                    style={{
                      left: "-8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      borderTop: "8px solid transparent",
                      borderBottom: "8px solid transparent",
                      borderRight: "8px solid white",
                    }}
                  />
                  <p
                    className="text-masmed-gray-900 text-xs md:text-sm mb-1.5"
                    style={{
                      fontFamily: "'Arial', 'Helvetica', sans-serif",
                      fontWeight: 700,
                    }}
                  >
                    Comuna de {selectedComuna.nombre}
                  </p>
                  <div className="space-y-1">
                    <p className="text-masmed-gray-500 text-xs leading-snug">
                      <span
                        className="text-masmed-gray-700"
                        style={{
                          fontFamily: "'Arial', 'Helvetica', sans-serif",
                          fontWeight: 600,
                        }}
                      >
                        N° de Habitantes:
                      </span>{" "}
                      {selectedComuna.habitantes.toLocaleString("es-CL")}
                    </p>
                    <p className="text-masmed-gray-500 text-xs leading-snug">
                      <span
                        className="text-masmed-gray-700"
                        style={{
                          fontFamily: "'Arial', 'Helvetica', sans-serif",
                          fontWeight: 600,
                        }}
                      >
                        Especialistas:
                      </span>{" "}
                      {selectedComuna.especialistas}
                    </p>
                    <p className="text-masmed-gray-500 text-xs leading-snug">
                      <span
                        className="text-masmed-gray-700"
                        style={{
                          fontFamily: "'Arial', 'Helvetica', sans-serif",
                          fontWeight: 600,
                        }}
                      >
                        Centros médicos:
                      </span>{" "}
                      {selectedComuna.centrosMedicos}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Tooltip mobile: debajo del mapa */}
            <div className="md:hidden mt-4 bg-white rounded-xl shadow-md px-4 py-3">
              <p
                className="text-masmed-gray-900 text-sm mb-1.5"
                style={{
                  fontFamily: "'Arial', 'Helvetica', sans-serif",
                  fontWeight: 700,
                }}
              >
                Comuna de {selectedComuna.nombre}
              </p>
              <div className="space-y-1">
                <p className="text-masmed-gray-500 text-xs">
                  <span
                    className="text-masmed-gray-700"
                    style={{
                      fontFamily: "'Arial', 'Helvetica', sans-serif",
                      fontWeight: 600,
                    }}
                  >
                    N° de Habitantes:
                  </span>{" "}
                  {selectedComuna.habitantes.toLocaleString("es-CL")}
                </p>
                <p className="text-masmed-gray-500 text-xs">
                  <span
                    className="text-masmed-gray-700"
                    style={{
                      fontFamily: "'Arial', 'Helvetica', sans-serif",
                      fontWeight: 600,
                    }}
                  >
                    Especialistas:
                  </span>{" "}
                  {selectedComuna.especialistas}
                </p>
                <p className="text-masmed-gray-500 text-xs">
                  <span
                    className="text-masmed-gray-700"
                    style={{
                      fontFamily: "'Arial', 'Helvetica', sans-serif",
                      fontWeight: 600,
                    }}
                  >
                    Centros médicos:
                  </span>{" "}
                  {selectedComuna.centrosMedicos}
                </p>
              </div>
            </div>
          </div>

          {/* Columna derecha: 3 donuts apilados */}
          <div className="w-full lg:w-[180px] flex flex-row lg:flex-col items-center justify-between gap-4 shrink-0 order-3">
            {rightIndicators.map((ind, idx) => (
              <DonutIndicator
                key={`right-${idx}`}
                valor={ind.valor}
                titulo={ind.titulo}
                subtitulo={ind.subtitulo}
              />
            ))}
          </div>
        </div>

        {/* Leyenda centrada bajo el mapa */}
        <div className="flex items-center justify-center gap-5 mt-6 md:mt-8">
          <div className="flex items-center gap-2">
            <span className="w-[7px] h-[7px] rounded-full bg-[#356182]" />
            <span className="text-masmed-gray-500 text-xs">Comunas</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-[7px] h-[7px] rounded-full bg-[#F15A24]" />
            <span className="text-masmed-gray-500 text-xs">Seleccionada</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-[7px] h-[7px] rounded-full bg-white border border-[#8A8A8A]" />
            <span className="text-masmed-gray-500 text-xs">No seleccionada</span>
          </div>
        </div>
      </div>
    </section>
  );
}